module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/incidences/incidence-filter/incidence-filter.component.sass
// module id = ./src/app/incidences/incidence-filter/incidence-filter.component.sass
// module chunks = main